import { useTranslation } from "react-i18next";

import { isTranslationKey } from "../helpers";

export const useTranslationConditional = () => {
  const { t } = useTranslation();

  const tConditional = (message: string): string =>
    isTranslationKey(message) ? t(message) : message;
  return { tConditional };
};
